// AirportConveyanceModal.jsx
import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./AirportConveyanceModal.module.css";


const AirportConveyanceModal = ({ isOpen, onClose, onConfirm }) => {
  const [direction, setDirection] = useState('pickup'); // 'pickup', 'dropoff', 'both'
  const [pickupDate, setPickupDate] = useState(null);
  const [pickupTime, setPickupTime] = useState(null);
  const [pickupPhone, setPickupPhone] = useState("");
  const [pickupAirport, setPickupAirport] = useState("");
  const [dropoffDate, setDropoffDate] = useState(null);
  const [dropoffTime, setDropoffTime] = useState(null);
  const [dropoffPhone, setDropoffPhone] = useState("");
  const [dropoffAirport, setDropoffAirport] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    const newErrors = {};
    if (direction === 'pickup' || direction === 'both') {
      if (!pickupDate) newErrors.pickupDate = "Please select pickup date.";
      if (!pickupTime) newErrors.pickupTime = "Please select pickup time.";
      if (!pickupPhone.trim()) newErrors.pickupPhone = "Please enter pickup phone number.";
      if (!pickupAirport) newErrors.pickupAirport = "Please select pickup airport.";
    }
    if (direction === 'dropoff' || direction === 'both') {
      if (!dropoffDate) newErrors.dropoffDate = "Please select drop-off date.";
      if (!dropoffTime) newErrors.dropoffTime = "Please select drop-off time.";
      if (!dropoffPhone.trim()) newErrors.dropoffPhone = "Please enter drop-off phone number.";
      if (!dropoffAirport) newErrors.dropoffAirport = "Please select drop-off airport.";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    // Format dates and times
    const formatDate = (date) => date?.toLocaleDateString("en-US", { month: "long", day: "numeric" });
    const formatTime = (time) => time?.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });

    const data = {
      direction,
      pickup: direction === 'pickup' || direction === 'both' ? {
        date: formatDate(pickupDate),
        time: formatTime(pickupTime),
        phone: pickupPhone,
        airport: pickupAirport === "abuja"
          ? "Nnamdi Azikiwe Int'l"
          : pickupAirport === "lagos"
          ? "Murtala Muhammed Int'l"
          : pickupAirport === "phc"
          ? "Port Harcourt Int'l"
          : "",
      } : null,
      dropoff: direction === 'dropoff' || direction === 'both' ? {
        date: formatDate(dropoffDate),
        time: formatTime(dropoffTime),
        phone: dropoffPhone,
        airport: dropoffAirport === "abuja"
          ? "Nnamdi Azikiwe Int'l"
          : dropoffAirport === "lagos"
          ? "Murtala Muhammed Int'l"
          : dropoffAirport === "phc"
          ? "Port Harcourt Int'l"
          : "",
      } : null,
    };
    onConfirm(data);
    onClose();
  };

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.conveyanceModal}>
        <div className={styles.modalHeader}>
          <h1>Airport Conveyance</h1>
          <button className={styles.closeBtn} onClick={onClose}>
            ×
          </button>
        </div>
        <p className={styles.modalSubtext}>
          Select your airport conveyance option. Pricing: <br />
          <strong>₦40,000</strong> for Pickup, <strong>₦40,000</strong> for Drop-off, <strong>₦70,000</strong> for Both. Free for stays of 10+ nights.
        </p>
        <div className={styles.modalForm}>
          <div className={styles.radioGroup}>
            <label className={styles.radioLabel}>
              <input type="radio" name="direction" value="pickup" checked={direction === 'pickup'} onChange={() => setDirection('pickup')} />
              <span>Pickup</span>
            </label>
            <label className={styles.radioLabel}>
              <input type="radio" name="direction" value="dropoff" checked={direction === 'dropoff'} onChange={() => setDirection('dropoff')} />
              <span>Drop-off</span>
            </label>
            <label className={styles.radioLabel}>
              <input type="radio" name="direction" value="both" checked={direction === 'both'} onChange={() => setDirection('both')} />
              <span>Both</span>
            </label>
          </div>
          {(direction === 'pickup' || direction === 'both') && (
            <>
              <h4>Pickup Details</h4>
              <div className={styles.row}>
                <div className={styles.inputWrapper}>
                  <DatePicker
                    selected={pickupDate}
                    onChange={(date) => setPickupDate(date)}
                    dateFormat="MMMM d"
                    placeholderText="Select Pickup Date"
                    minDate={new Date()}
                    className={styles.styledDatepicker}
                  />
                  {errors.pickupDate && <p className={styles.formError}>{errors.pickupDate}</p>}
                </div>
                <div className={styles.inputWrapper}>
                  <DatePicker
                    selected={pickupTime}
                    onChange={(time) => setPickupTime(time)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={30}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    placeholderText="Select Pickup Time"
                    className={styles.styledDatepicker}
                  />
                  {errors.pickupTime && <p className={styles.formError}>{errors.pickupTime}</p>}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.inputWrapper}>
                  <input
                    type="tel"
                    placeholder="Enter Pickup Phone Number"
                    value={pickupPhone}
                    onChange={(e) => setPickupPhone(e.target.value)}
                  />
                  {errors.pickupPhone && <p className={styles.formError}>{errors.pickupPhone}</p>}
                </div>
                <div className={styles.inputWrapper}>
                  <select
                    value={pickupAirport}
                    onChange={(e) => setPickupAirport(e.target.value)}
                  >
                    <option value="">Select Pickup Airport</option>
                    <option value="abuja">Nnamdi Azikiwe Int'l</option>
                    <option value="lagos">Murtala Muhammed Int'l</option>
                    <option value="phc">Port Harcourt Int'l</option>
                  </select>
                  {errors.pickupAirport && <p className={styles.formError}>{errors.pickupAirport}</p>}
                </div>
              </div>
            </>
          )}
          {(direction === 'dropoff' || direction === 'both') && (
            <>
              <h4>Drop-off Details</h4>
              <div className={styles.row}>
                <div className={styles.inputWrapper}>
                  <DatePicker
                    selected={dropoffDate}
                    onChange={(date) => setDropoffDate(date)}
                    dateFormat="MMMM d"
                    placeholderText="Select Drop-off Date"
                    minDate={new Date()}
                    className={styles.styledDatepicker}
                  />
                  {errors.dropoffDate && <p className={styles.formError}>{errors.dropoffDate}</p>}
                </div>
                <div className={styles.inputWrapper}>
                  <DatePicker
                    selected={dropoffTime}
                    onChange={(time) => setDropoffTime(time)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={30}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    placeholderText="Select Drop-off Time"
                    className={styles.styledDatepicker}
                  />
                  {errors.dropoffTime && <p className={styles.formError}>{errors.dropoffTime}</p>}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.inputWrapper}>
                  <input
                    type="tel"
                    placeholder="Enter Drop-off Phone Number"
                    value={dropoffPhone}
                    onChange={(e) => setDropoffPhone(e.target.value)}
                  />
                  {errors.dropoffPhone && <p className={styles.formError}>{errors.dropoffPhone}</p>}
                </div>
                <div className={styles.inputWrapper}>
                  <select
                    value={dropoffAirport}
                    onChange={(e) => setDropoffAirport(e.target.value)}
                  >
                    <option value="">Select Drop-off Airport</option>
                    <option value="abuja">Nnamdi Azikiwe Int'l</option>
                    <option value="lagos">Murtala Muhammed Int'l</option>
                    <option value="phc">Port Harcourt Int'l</option>
                  </select>
                  {errors.dropoffAirport && <p className={styles.formError}>{errors.dropoffAirport}</p>}
                </div>
              </div>
            </>
          )}
          <textarea placeholder="Give us any extra details"></textarea>
          <button type="button" className={styles.sendBtn} onClick={handleSubmit}>
            SEND
          </button>
        </div>
      </div>
    </div>
  );
};

export default AirportConveyanceModal;
